import { gql } from "graphql-request";

const SERVER_GET_AREAS_NAME = gql`
{
  areaNames
}
`

export default SERVER_GET_AREAS_NAME;
